/**
 * `window` event the workbench dispatches when the preview shows only the starter template and
 * the founder clicks "Build prototype". The conversation module listens and retries the latest
 * plan's build (`handleRetryPrototyper`), the same as the prototype card's Retry.
 */
export const WORKBENCH_BUILD_MISSING_VERSION_EVENT = 'ideoz-workbench-build-missing-version';

/**
 * `window` events from the "saved in another tab" banner (P6.4e): load the newest saved version of
 * the turn, or save this tab's copy over it. The workbench facade listens.
 */
export const WORKBENCH_SAVE_CONFLICT_LOAD_LATEST_EVENT = 'ideoz-workbench-save-conflict-load-latest';
export const WORKBENCH_SAVE_CONFLICT_KEEP_MINE_EVENT = 'ideoz-workbench-save-conflict-keep-mine';

/**
 * `window` event from hot edit's "Ask Ideoz about this element": `detail.text` names the element,
 * its file and line. The conversation module puts it into the chat composer without sending it.
 */
export const HOT_EDIT_ASK_IDEOZ_EVENT = 'ideoz-hot-edit-ask-ideoz';

/**
 * `window` event after Apply wrote a design system change (a colour or the corner style):
 * `detail.patch` is the body for `PATCH /projects/:id/design-system`. The prototyper module
 * listens and sends it, so the change becomes the startup's design system rather than one
 * prototype's stylesheet - every generation after it is built with the founder's colour.
 */
export const HOT_EDIT_DESIGN_SYSTEM_EVENT = 'ideoz-hot-edit-design-system';
